'use strict';

const { h } = require('phy');

function Breadcrumbs(breadcrumbList) {
  if (!breadcrumbList || !breadcrumbList.length) {
    return null;
  }

  return h(
    '.breadcrumbs',
    {
      'data-bhw': 'Breadcrumbs',
    },
    breadcrumbList.map(breadcrumb =>
      h(
        'a',
        { href: breadcrumb.route, 'data-bhc': breadcrumb.bloodhound },
        breadcrumb.name
      )
    )
  );
}

module.exports = Breadcrumbs;
